import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'
import { america, findMission } from '@/content/missions'
import { findTemplate } from '@/content/templates'
import { templateComponents } from '@/templates/registry'
import { previewPath, templateIds, type TemplateId } from '@/templates/types'
import { usePrefs } from '@/state/prefs'
import { OPERATOR } from '@/content/provenance'

/**
 * A template as a whole page, in the visitor's chosen mission and theme. The
 * template detail page frames this route; it reloads when those choices change
 * in another tab or in the page that frames it.
 */
export default function TemplatePreviewPage() {
  const { slug } = useParams()
  const { prefs } = usePrefs()
  const known = templateIds.includes(slug as TemplateId)
  const id: TemplateId = known ? (slug as TemplateId) : 'agency-home'
  const Template = templateComponents[id]
  const mission = findMission(prefs.mission) ?? america

  useEffect(() => {
    document.title = `${findTemplate(id)?.name} | ${mission.name}`
  }, [id, mission.name])

  useEffect(() => {
    const onStorage = (event: StorageEvent) => {
      if (event.key?.startsWith('mds:')) window.location.reload()
    }
    window.addEventListener('storage', onStorage)
    return () => window.removeEventListener('storage', onStorage)
  }, [])

  // An unknown template goes back to the gallery.
  if (!known) return <Navigate to="/templates" replace />
  return (
    <Template
      mission={mission}
      link={previewPath}
      credit={
        <>
          A Mission Design System template. Built by <a href={OPERATOR.url}>{OPERATOR.name}</a>.
        </>
      }
    />
  )
}
